import React, { useState, useEffect } from 'react';
import Layout from '../../components/layout/Layout';
import alertaService from '../../services/alertaService';
import { formatearFecha } from '../../utils/helpers';
import { FaBell, FaCheck, FaCheckDouble, FaPaperPlane } from 'react-icons/fa';
import api from '../../services/api';

export default function AlertasPage() {
  const [alertas,   setAlertas]   = useState([]);
  const [cargando,  setCargando]  = useState(true);
  const [enviando,  setEnviando]  = useState(false);
  const [msgEnvio,  setMsgEnvio]  = useState('');
  const [form, setForm] = useState({ titulo: '', mensaje: '' });

 useEffect(() => { 
  cargarAlertas(); 
  const intervalo = setInterval(cargarAlertas, 30000);
  return () => clearInterval(intervalo);
}, []);

  const cargarAlertas = async () => {
    setCargando(true);
    try {
      const data = await alertaService.listarNoLeidas();
      setAlertas(data);
    } finally {
      setCargando(false);
    }
  };

  const handleMarcarLeida = async (id) => {
    await alertaService.marcarLeida(id);
    cargarAlertas();
  };

  const handleMarcarTodas = async () => {
    await alertaService.marcarTodasLeidas();
    cargarAlertas();
  };

  const handleEnviarContador = async (e) => {
    e.preventDefault();
    if (!form.titulo || !form.mensaje) return;
    setEnviando(true);
    setMsgEnvio('');
    try {
      const { data } = await api.post('/alertas/enviar-contador', form);
      setMsgEnvio('' + data.message);
      setForm({ titulo: '☑', mensaje: '' });
    } catch (err) {
      setMsgEnvio('☒ Error al enviar la alerta.');
    } finally {
      setEnviando(false);
    }
  };

  const getBadgeTipo = (tipo) => {
    const colores = {
      presupuesto: 'bg-danger',
      vencimiento: 'bg-warning text-dark',
      informativa: 'bg-info',
    };
    return colores[tipo] || 'bg-secondary';
  };

  return (
    <Layout>
      <div className="page-header d-flex justify-content-between align-items-center">
        <div>
          <h4>Alertas</h4>
          <p>Notificaciones y alertas del sistema</p>
        </div>
        {alertas.length > 0 && (
          <button className="btn btn-outline-secondary" onClick={handleMarcarTodas}>
            <FaCheckDouble className="me-2" /> Marcar todas como leídas
          </button>
        )}
      </div>

      <div className="row g-3">

        {/* Formulario enviar alerta al contador */}
        <div className="col-md-4">
          <div className="card card-custom">
            <div className="card-body">
              <h6 className="fw-bold mb-3">
                <FaPaperPlane className="me-2 text-danger" />
                Enviar Alerta al Contador
              </h6>
              <form onSubmit={handleEnviarContador}>
                <div className="mb-3">
                  <label className="form-label fw-bold">Título *</label>
                  <input
                    className="form-control"
                    placeholder="Asunto de la alerta"
                    value={form.titulo}
                    onChange={e => setForm(p => ({ ...p, titulo: e.target.value }))}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label fw-bold">Mensaje *</label>
                  <textarea
                    className="form-control"
                    rows={4}
                    placeholder="Escribe el mensaje para el contador..."
                    value={form.mensaje}
                    onChange={e => setForm(p => ({ ...p, mensaje: e.target.value }))}
                    required
                  />
                </div>
                {msgEnvio && (
                  <div className={`alert ${msgEnvio.includes('✅') ? 'alert-success' : 'alert-danger'} py-2`}>
                    {msgEnvio}
                  </div>
                )}
                <button
                  type="submit"
                  className="btn btn-danger w-100"
                  disabled={enviando}
                >
                  <FaPaperPlane className="me-2" />
                  {enviando ? 'Enviando...' : 'Enviar al Contador'}
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* Lista de alertas */}
        <div className="col-md-8">
          <div className="card card-custom">
            <div className="card-body">
              {cargando ? (
                <div className="text-center py-4">
                  <div className="spinner-custom mx-auto" />
                </div>
              ) : alertas.length > 0 ? (
                alertas.map((a) => (
                  <div key={a.id} className="alerta-item">
                    <div className="d-flex justify-content-between align-items-start">
                      <div className="d-flex gap-3 align-items-start">
                        <div className="alerta-icon">
                          <FaBell />
                        </div>
                        <div>
                          <div className="d-flex align-items-center gap-2 mb-1">
                            <strong>{a.titulo}</strong>
                            <span className={`badge ${getBadgeTipo(a.tipo_alerta)}`}>
                              {a.tipo_alerta}
                            </span>
                          </div>
                          <p className="mb-1 text-muted small">{a.mensaje}</p>
                          <small className="text-muted">{formatearFecha(a.created_at)}</small>
                        </div>
                      </div>
                      <button
                        className="btn btn-sm btn-outline-success"
                        onClick={() => handleMarcarLeida(a.id)}
                        title="Marcar como leída"
                      >
                        <FaCheck />
                      </button>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center py-5">
                  <FaBell size={48} className="text-muted mb-3 d-block mx-auto" />
                  <h6 className="text-muted">Sin alertas pendientes</h6>
                  <p className="text-muted small">Todas las alertas han sido revisadas</p>
                </div>
              )}
            </div>
          </div>
        </div>

      </div>
    </Layout>
  );
}